module.exports = __webpack_public_path__ + "static/media/text-align-center-white.d7fed0a2.svg";